import { BehaviorSubject, Observable, Subject, UnaryFunction } from "rxjs";

import { Sort } from "@angular/material/sort";
import { CallState } from "@app/root-store/api-result.state";
import { IFilters } from "../services/filter.service";

export interface TableAction {
    title: string;
    icon?: string;
    isDisabled?: boolean;
    emitAction: any;
    allows?: string[];
}

export enum TableActionDisplay {
    default = "default", // base on the number of actions, display as collapsed or overflow
    collapsed = "collapsed", // display the actions as the dropdown list in table column
    overflow = "overflow", // display the actions as the inline list
    separated = "separated", // display the actions as the dropdown list in the top of table
    dynamicBar = "dynamicBar", // display the actions as the icon-button list in the top of the table
    noaction = "noaction", // no action display
}

export type DataSortType = "datetime" | "string" | "default";

export interface TableColumnDef {
    displayName: string;
    dataSortType?: "datetime" | "string" | "default";
}

export type TableColumns = Record<string, string | TableColumnDef> | { _listStructure?: string[][] };

export interface TableActionOptions<T = any> {
    display: TableActionDisplay;
    selectionListener: (selectedRow: T, subject: Subject<TableAction[]>) => void;
}

export interface TableFilterProperties {
    selectedFilters?: IFilters;
    searchTerm?: string;
    columnsToSearch?: string[];
}

export type ClareSort = Sort & {
    dataSortType: "datetime" | "string" | "default";
};

export interface TablePageProperties {
    pageIndex: number;
    pageSize: number;
    active: string;
    dataSortType: "datetime" | "string" | "default";
    direction: "asc" | "desc" | "";
}

export interface IClareTableComponent<T = any> {
    callState$?: Observable<CallState<T>>;
    dataSource$: Observable<any[] | Error>;
    dataSourceLength?: number;
    columns?: Record<string, string>;
    columns$?: Observable<TableColumns>;
    tableActionOptions: TableActionOptions;
    tableProperties$?: BehaviorSubject<TableFilterProperties>;
    getTableActions?: () => (selectedRow: T) => TableAction[];
    tableActions?: (selectedRow: T) => TableAction[];
    updateTableProperties?: (updatedProperties: Partial<TableFilterProperties>) => BehaviorSubject<TableFilterProperties>;
    paginateData?: () => UnaryFunction<Observable<any[]>, Observable<any[]>>;
}
